import React from 'react';

import type { TNamedContainer } from '../models';

/**
 * Компонент хоть никогда не вернет значение в vdom, оставляем рендер детей для тестов и для типов
 */
export const NamedContainer: TNamedContainer = ({ children }) => <>{children}</>;

/**
 * Подсказка для devtools, раньше этот вопрос решала обертка createWidget()
 */
NamedContainer.displayName = 'NamedContainer';

/**
 * Хелпер. чтоб проверить что Named is Named
 */
NamedContainer.defaultProps = { is: 'NamedContainer' };
